import * as queryString from 'query-string'
import * as React from 'react'

import { Site } from '../../../common/constants/siteList'
import { IStudioRecommendations } from '../../../typings/studioRecommendations'

interface IProps {
  config: IStudioRecommendations
  currentSite: Site
  category: string
  term: string
}

const StudioRecommendationsBanner = ({
  config,
  currentSite,
  category,
  term
}: IProps) => {
  const items = config.items
  const generation = config.generation

  const getLinkParams = (itemId: number) => {
    const params = {
      utm_campaign: 'shervinator',
      utm_source: 'marketplace',
      utm_medium: currentSite,
      utm_term: category || term,
      utm_content: `${generation}_${items
        .map(item => item.id)
        .join('_')}_${itemId}`
    }

    const queries = queryString.stringify(params)
    return queries
  }
  const logoName =
    'envato_studio-bd2d137aace64c47493f1c650a5596ab61069a0d53e5866070a83f879585f054.svg'

  return (
    <div className="studio-recommendations fds-u-mb4 fds-u-p1">
      <a
        className="studio-recommendations__logo fds-u-m1 fds-u-mb2"
        href="https://studio.envato.com/"
      >
        <img
          src={`https://public-assets.envato-static.com/assets/logos/${logoName}`}
          alt="Envato Studio logo"
        />
      </a>
      <div className="studio-recommendations__list">
        <ul className="fds-c-text-list -style-none">
          {items.map(item => (
            <li className="fds-c-text-body fds-u-m1" key={item.id}>
              <a
                href={item.url + '?' + getLinkParams(item.id)}
                className="fds-c-text-link -decoration-reversed"
              >
                {item.name}
              </a>{' '}
              from ${item.price_from}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default StudioRecommendationsBanner
